import {APP_INITIALIZER, NgModule} from '@angular/core';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {BASE_PATH} from './api';
import {BrowserModule} from '@angular/platform-browser';
import {OAuthModule, OAuthService} from 'angular-oauth2-oidc';

import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {provideAnimationsAsync} from '@angular/platform-browser/animations/async';
import {providePrimeNG} from 'primeng/config';
import {LoginComponent} from './auth/login/login.component';
import {CallbackComponent} from './auth/callback/callback.component';
import {DashboardComponent} from './dashboard/dashboard.component';
import {LayoutComponent} from './shared/layout/layout.component';
import {DrawerMenuComponent} from './shared/layout/drawer-menu/drawer-menu.component';
import {PopoverMenuComponent} from './shared/layout/popover-menu/popover-menu.component';
import {Popover} from 'primeng/popover';
import {Drawer} from 'primeng/drawer';
import {ToastComponent} from './shared/toast/toast.component';
import {Toast} from 'primeng/toast';
import {NgIcon} from '@ng-icons/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {AuthInterceptor} from './auth/auth.interceptor';
import {ConfirmationService, MessageService} from 'primeng/api';
import {Dialog, DialogModule} from 'primeng/dialog';
import {ServicesModule} from './services/services.module';
import {ButtonModule} from 'primeng/button';
import {TableModule} from 'primeng/table';
import {ChartModule} from 'primeng/chart';
import {DatePickerModule} from 'primeng/datepicker';
import {SelectButtonModule} from 'primeng/selectbutton';
import {TreeModule} from 'primeng/tree';
import Aura from '@primeuix/themes/aura';
import {DialogService} from 'primeng/dynamicdialog';
import {SharedModule} from './shared/shared.module';
import {authConfig} from './auth/auth.config';
import {AuthService} from './auth/auth.service';

export function initAuth(oauthService: OAuthService, authService: AuthService): () => Promise<boolean> {
  return () => {
    oauthService.configure(authConfig);
    oauthService.setupAutomaticSilentRefresh();
    return authService.loadDiscoveryDocumentAndTryLogin();
  };
}

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    CallbackComponent,
    DashboardComponent,
    LayoutComponent,
    DrawerMenuComponent,
    PopoverMenuComponent,
    ToastComponent
  ],
  imports: [
    BrowserModule, ReactiveFormsModule, HttpClientModule,
    AppRoutingModule, Popover, Drawer, Toast, NgIcon, Dialog, ServicesModule, FormsModule, ButtonModule, DialogModule, TableModule,
    ChartModule, DatePickerModule, SelectButtonModule, TreeModule,
    SharedModule,
    OAuthModule.forRoot()
  ],
  providers: [
    {
      provide: APP_INITIALIZER,
      useFactory: initAuth,
      deps: [OAuthService, AuthService],
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    provideAnimationsAsync(),
    providePrimeNG({
      theme: {
        preset: Aura,
        options: {
          darkModeSelector: false
        }
      }
    }),
    {provide: BASE_PATH, useValue: ''},
    MessageService,
    ConfirmationService,
    DialogService
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
}
